import {
    HeaderMenu,
    Card,
    DateInput,
    Select,
    BaseTable,
    Loading,
    PaginationData,
    TableNumber,
    Button,
    PermissionLink
} from "components"
import moment from "moment"
import { useEffect } from "react"
import { invoiceListStore } from "./utils/invoiceListStore"
import { useInvoiceList } from "./utils/useInvoiceList"
import { convertNumber, getStatusLabel, STATUS, STATUS_OPTIONS } from "utils"
import { PERMISION } from "security"

export default function ListInvoiceAdjustment(){
    const {
        filter,
        pagination_data,
        data,
        isLoading,
        setFilter,
        setPaginationData,
    } = invoiceListStore()

    const { fetchData } = useInvoiceList()

    useEffect(() => {
        fetchData()
        // eslint-disable-next-line
    }, [filter, pagination_data.page, pagination_data.limit])

    useEffect(() => {
        fetchData()
        // eslint-disable-next-line
    }, [])
    
    return(
        <section>
            <section className="mt-1 mx-3">
                <HeaderMenu title="INVOICE LIST" />
            </section>

            <section className="mx-3">
            <Card>
            <Card.Body>
                <section className="lg:flex overflow-x-auto">
                <div className="flex w-full"> 
                    <div className="flex items-center w-[284px] lg:w-[250px] mx-2">
                    <div className="label-text pb-1 font-bold pe-2 lg:w-[145px] w-[350px] uppercase">
                        START DATE
                    </div>
                    <DateInput
                        className="!w-[150px]"
                        selected={moment(filter.DateFrom).toDate()}
                        onChange={(date) =>
                        setFilter({
                            ...filter,
                            DateFrom: moment(date).format("YYYY-MM-DD")
                        })
                        }
                    />
                    </div>
                    <div className="flex items-center w-[284px] lg:w-[250px] mt-2 lg:mt-0 mx-2">
                        <div className="lg:mt-0 lg:px-2 pb-1 label-text font-bold lg:w-[110px] !w-[550px] uppercase">
                            END DATE
                        </div>
                        <DateInput
                            className="!w-[150px]"
                            selected={moment(filter.DateEnd).toDate()}
                            onChange={(date) =>
                            setFilter({
                                ...filter,
                                DateEnd: moment(date).format("YYYY-MM-DD")
                            })
                            }
                        />
                    </div>
                    <div className="flex items-center ml-1 mt-2 lg:mt-0 mx-2">
                        <div className="lg:mt-0 lg:px-2 pb-1 label-text font-bold w-[142px] lg:w-full">
                            STATUS
                        </div>
                        <Select
                            className="min-w-[150px]"
                            value={
                                STATUS_OPTIONS.find(
                                    (opt) => opt.value?.toString() === filter.invoice_status?.toString()
                                ) || STATUS_OPTIONS[0] // default ALL
                            }
                            options={STATUS_OPTIONS}
                            onChange={(e) => {
                                setFilter({
                                    ...filter,
                                    invoice_status: e?.value ?? STATUS.ALL,
                                })
                            }}
                        />
                    </div>
                </div>
                
                <div className="">
                   
                </div>
                </section>
            </Card.Body>
            </Card>
            </section>

            <section className="mx-3">
                <Card>
                <Card.Body>
                    <div className="overflow-x-auto max-h-[calc(100vh-500px)]">
                    <BaseTable>
                        <thead className="top-0 z-1 !bg-black !text-white">
                        <tr>
                            <th>NO</th>
                            <th>INVOICE ID#</th>
                            <th className="min-w-[150px]">DATE</th>
                            <th>SO ID#</th>
                            <th>STATUS</th>
                            <th>CUSTOMER</th>
                            <th>FREIGHT</th>
                            <th>ITEM DETAIL</th>
                            <th>TAX</th>
                            <th>REFUND</th>
                            <th>SALDO</th>
                            <th>ACTION</th>
                        </tr>
                        </thead>
                        <tbody>
                        {isLoading || data?.length === 0 ? (
                            <tr>
                            <td colSpan={12}>
                                <Loading
                                loading={isLoading}
                                errorText="No data available"
                                />
                            </td>
                            </tr>
                        ) : (
                            data.map((item,index) => {

                                return(
                                    <tr key={index}>
                                        <td>
                                            {TableNumber({
                                                pageCurrent: pagination_data?.page,
                                                dataLength: pagination_data?.size!,
                                                index: index,
                                                limit: pagination_data?.limit,
                                                totalData: pagination_data?.total
                                            })}
                                        </td>
                                        <td>{item.trx_code}</td>
                                        <td className="text-center">{moment(item.transaction_date).format('DD/MM/YYYY')}</td>
                                        <td>{item.so_code}</td>
                                        <td className="text-center">{getStatusLabel(String(item.invoice_status)) ?? "-"}</td>
                                        <td>{item.customer_name}</td>
                                        <td className="text-end">{convertNumber(Number(item.freight)).intoCurrency}</td>
                                        <td className="text-end">{convertNumber(Number(item.total_invoice)).intoCurrency}</td>
                                        <td className="text-end">{convertNumber(Number(item.total_tax)).intoCurrency}</td>
                                        <td className="text-end">{convertNumber(Number(item.tot_payment)).intoCurrency}</td>
                                        <td className="text-end">{convertNumber(Number(item.freight) + Number(item.total_invoice) + Number(item.total_tax) - Number(item.tot_payment)).intoCurrency }</td>
                                        <td className="text-center">
                                            {String(item.invoice_status) === '1' && (
                                                <PermissionLink permission={PERMISION.SALES.TRANSACTION.ADJUSTMENT_FREIGHT_INVOICE.UPDATE}
                                                    to={`/sales/transaction/adjustment-freight/${item.invoice_id}`}
                                                >
                                                    <Button color="primary">ADJUSTMENT</Button>
                                                </PermissionLink>
                                            )}
                                        </td>
                                    </tr>
                                )
                            })
                        )}
                        </tbody>
                    </BaseTable>
                    </div>

                    <div className="mt-3">
                        <PaginationData
                            data={data}
                            pagination={pagination_data}
                            setPagination={setPaginationData}
                        />
                    </div>

                </Card.Body>
                </Card>
            </section>
            
        </section>
    )
}
